import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../shared/DeleteButton.js';
import ProjectDropdown from '../shared/dropdowns/ProjectDropdown.js';
import './FinanceCardList.css';

const FinanceCard = ({ row, onDeleted, currencySymbol, projects, onProjectChange }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const typeClass = row.type === 'gain' ? 'gain' : 'loss';

  return (
    <div className={`finance-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="finance-card-main">
        <div className={`finance-card-type ${typeClass}`} />
        <div className="finance-card-category">{row.category ? t(row.category, { defaultValue: row.category }) : '—'}</div>
        <div className={`finance-card-amount ${typeClass}`}>
          {row.type === 'gain' ? '+' : '-'}{currencySymbol}{Number(row.amount || 0).toFixed(2)}
        </div>
        <div className="finance-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="finance-card-secondary">
          {row.date?.substring(0, 10) || '—'}
          {row.notes && <> · {row.notes}</>}
        </div>
      </div>

      {expanded && (
        <div className="finance-card-detail" onClick={e => e.stopPropagation()}>
          <div className="finance-card-detail-row">
            <span>{t('type')}</span>
            <span>{row.type === 'gain' ? t('gain') : t('loss')}</span>
          </div>
          <div className="finance-card-detail-row">
            <span>{t('amount')}</span>
            <span>{currencySymbol}{Number(row.amount || 0).toFixed(2)}</span>
          </div>
          <div className="finance-card-detail-row">
            <span>{t('category')}</span>
            <span>{row.category ? t(row.category, { defaultValue: row.category }) : '—'}</span>
          </div>
          <div className="finance-card-detail-row">
            <span>{t('institution')}</span>
            <span>{row.institution ? t(row.institution, { defaultValue: row.institution }) : '—'}</span>
          </div>
          {/* Only where a transaction can be moved (Finances → Transactions);
              a project's own page leaves it out. */}
          {onProjectChange && (
            <div className="finance-card-detail-row">
              <span>{t('project')}</span>
              <ProjectDropdown
                projects={projects}
                selected={row.project_id}
                onChange={(e) => onProjectChange(row, e.target.value)}
              />
            </div>
          )}
          {row.notes && (
            <div className="finance-card-detail-row">
              <span>{t('notes')}</span>
              <span>{row.notes}</span>
            </div>
          )}
          <div className="finance-card-detail-row">
            <span>{t('date')}</span>
            <span>{row.date?.substring(0, 10) || '—'}</span>
          </div>
          <div className="finance-card-detail-row">
            <span>{t('who')}</span>
            <span>{row.created_by || '—'}</span>
          </div>
          <div className="finance-card-actions">
            <DeleteButton
              collection="finance.transactions"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const FinanceCardList = ({ data, onRefresh, currencySymbol = 'R$', projects, onProjectChange, className = '' }) => {
  return (
    <div className={`finance-card-list ${className}`}>
      {data && data.map(row => (
        <FinanceCard key={row._id} row={row} onDeleted={onRefresh} currencySymbol={currencySymbol}
          projects={projects} onProjectChange={onProjectChange} />
      ))}
      {(!data || data.length === 0) && (
        <div className="finance-card-empty">—</div>
      )}
    </div>
  );
};

export default FinanceCardList;
